import {acceptHMRUpdate, defineStore} from 'pinia';

export const useDashboardStore = defineStore('dashboard', {
  state: () => {
    return {
      dashboard: {
        meetingsToday: 0,
        newProjects: 0,
        calls: 0,
        nextProjects: 0,
      },
      loading: true,
      isError: false,
    };
  },
  actions: {
    getCountCalls() {
      this.loading = true;
      return window.connector.getCountCalls()
        .then((result: {
          count_relances: number
        }) => {
          this.isError = false;
          if (result) {
            this.dashboard.calls = result.count_relances;
          }
        })
        .catch((error) => {
          this.isError = true;
          throw new Error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCountOngoingRequest() {
      this.loading = true;
      return window.connector.getCountOngoingRequest()
        .then((result: {
          count_dem_new: number
        }) => {
          this.isError = false;
          if (result) {
            this.dashboard.newProjects = result.count_dem_new;
          }
        })
        .catch((error) => {
          this.isError = true;
          throw new Error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCountMeetingsToday() {
      this.loading = true;
      return window.connector.getCountMeetingsToday()
        .then((result: {
          count_meetings_today: number
        }) => {
          this.isError = false;
          if (result) {
            this.dashboard.meetingsToday = result.count_meetings_today;
          }
        })
        .catch((error) => {
          this.isError = true;
          throw new Error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDashboardStore, import.meta.hot))
}
